/**
 * BE BOLD : Path B: Release and Rebuild
 * Month 1: Pure Release (Days 1-30)
 *
 * No squeezing. No pushing. Just breath, position, and letting go.
 *
 * All sessions verified at 300s +/-20s (5 minutes)
 * Generated: 2026-04-13 02:14
 *
 * bebold.au | Paula Tomazetti | 16+ years of study
 * All content is 100% Be Bold.
 */

export const exercises = {

  belly_breath_drop: {
    id: 'belly_breath_drop',
    name: 'Belly Breath Drop',
    name_pt: 'Respiro da Barriga',
    sub: 'The floor drops on the inhale. Stay soft on the exhale.',
    sub_pt: 'O assoalho cai na inspiração. Fique macia na expiração.',
    level: 'Release',
    zone: 'Full floor 0-3cm',
    color: '#7A5A6A',
    movement: 'release',
    inst: `Lie on your back with your knees bent and feet flat. Place one hand on your lower belly.

Inhale slowly through your nose for 4 counts. Feel your belly rise under your hand. Your pelvic floor drops gently as your belly expands. You do not push it. It falls on its own.

Exhale through your mouth for 6 counts. Stay soft. Nothing tightens on the exhale. The floor stays dropped.

If you feel nothing at first, that is your starting point.

Picture it: your pelvic floor is a hammock between two trees. Each inhale, the hammock sinks wider. Each exhale, it stays low.`,
    inst_pt: `Deite de costas com os joelhos dobrados e pés apoiados. Coloque uma mão na barriga baixa.

Inspire lentamente pelo nariz por 4 tempos. Sinta a barriga subir sob sua mão. Seu assoalho pélvico desce suavemente conforme a barriga expande. Você não empurra. Ele cai sozinho.

Expire pela boca por 6 tempos. Fique macia. Nada contrai na expiração. O assoalho continua solto.

Se não sentir nada no início, esse é seu ponto de partida.

Visualize: seu assoalho pélvico é uma rede entre duas árvores. Cada inspiração, a rede afunda e alarga. Cada expiração, ela fica baixa.`,
    breathe: 'Inhale 4 counts to drop. Exhale 6 counts to stay soft.',
    breathe_pt: 'Inspire 4 tempos para soltar. Expire 6 tempos para ficar macia.',
    timerCue: `Inhale.
Drop.
Exhale.
Stay soft.`,
    timerCue_pt: `Inspire.
Solte.
Expire.
Fique macia.`,
    feel: 'A subtle widening and heaviness in the pelvic bowl on every inhale. Nothing tense. Nothing forced.',
    feel_pt: 'Uma sutil abertura e peso na pelve a cada inspiração. Nada tenso. Nada forçado.',
    avoid: 'Do not push the floor down. Do not bear down. Do not tighten on the exhale.',
    avoid_pt: 'Não empurre o assoalho para baixo. Não faça força. Não contraia na expiração.',
    type: 'hold',
    sets: 15,
    hold: 4,
    relax: 6,
    rest: 0,
  },

  body_scan_release: {
    id: 'body_scan_release',
    pose: 'body-scan',
    name: 'Body Scan Release',
    name_pt: 'Escaneamento Corporal',
    sub: 'Find where you hold tension. Let each place go.',
    sub_pt: 'Encontre onde você segura tensão. Deixe cada lugar soltar.',
    level: 'Release',
    zone: 'Full floor 0-3cm',
    color: '#8A6A7A',
    movement: 'neutral',
    inst: `Lie on your back, knees bent, feet flat. Close your eyes.

Start at your jaw. Is it clenched? Release it. Let your lips part.

Move to your shoulders. Are they lifted? Drop them into the floor.

Move to your belly. Is it held in? Let it round and soften.

Move to your inner thighs. Are they gripping? Let them fall open 1cm.

Move to your pelvic floor. Is it holding? Inhale and let it drop. Exhale and let it stay dropped.

Move to your buttocks. Are they squeezing? Release them into the mat.

Now breathe with everything released. Every exhale, scan again. If anything grabbed back, release it again.

Picture it: turning off lights in a house, room by room. Each room goes dark. By the end, the whole house is quiet. Or reading a checklist top to bottom: jaw done, shoulders done, belly done. Each checkmark means one area released.`,
    inst_pt: `Deite de costas, joelhos dobrados, pés apoiados. Feche os olhos.

Comece pelo maxilar. Está apertado? Solte. Deixe os lábios se separarem.

Vá para os ombros. Estão levantados? Solte-os no chão.

Vá para a barriga. Está contraída? Deixe arredondar e amolecer.

Vá para as coxas internas. Estão apertando? Deixe-as abrir 1cm.

Vá para o assoalho pélvico. Está segurando? Inspire e deixe cair. Expire e deixe ficar caído.

Vá para os glúteos. Estão apertando? Solte-os no chão.

Agora respire com tudo solto. Cada expiração, escaneie de novo. Se algo agarrou de volta, solte de novo.

Visualize: apagando as luzes de uma casa, cômodo por cômodo. Cada cômodo escurece. No final, a casa inteira está quieta. Ou lendo uma lista de cima para baixo: maxilar ok, ombros ok, barriga ok. Cada check significa uma área solta.`,
    breathe: 'Inhale to scan. Exhale to release what you find.',
    breathe_pt: 'Inspire para escanear. Expire para soltar o que encontrar.',
    timerCue: `Scan.
Find.
Breathe.
Release.`,
    timerCue_pt: `Escaneie.
Encontre.
Respire.
Solte.`,
    feel: 'Progressive lightness. Each area you release adds to the whole body softening.',
    feel_pt: 'Leveza progressiva. Cada área que solta adiciona ao corpo inteiro amolecendo.',
    avoid: 'Do not judge what you find. Do not force the release. If an area resists, breathe into it and move on.',
    avoid_pt: 'Não julgue o que encontrar. Não force a soltura. Se uma área resistir, respire nela e siga.',
    type: 'timed',
    sets: 1,
    hold: 150,
    rest: 0,
  },

  butterfly_breath: {
    id: 'butterfly_breath',
    pose: 'butterfly',
    name: 'Butterfly Breath',
    name_pt: 'Respiração Borboleta',
    sub: 'Knees open like wings. Floor opens with them.',
    sub_pt: 'Joelhos abrem como asas. Assoalho abre com eles.',
    level: 'Release',
    zone: 'Full floor 0-3cm',
    color: '#8A6A7A',
    movement: 'release',
    inst: `Lie on your back. Bring the soles of your feet together and let your knees fall open to the sides. If this pulls on your inner thighs, place pillows under each knee.

Inhale for 4 counts. Feel the gentle stretch across the inner thighs and perineum. Your pelvic floor widens naturally in this position.

Exhale for 6 counts. Let everything soften further. On each exhale, let the knees drop 1mm more.

Stay here and breathe. The position does the work.

Picture it: a butterfly resting with wings open on a warm rock. The wings do not flap. They just rest. Your knees are the wings.`,
    inst_pt: `Deite de costas. Junte as solas dos pés e deixe os joelhos caírem para os lados. Se puxar as coxas internas, coloque travesseiros sob cada joelho.

Inspire por 4 tempos. Sinta o alongamento suave nas coxas internas e períneo. Seu assoalho pélvico se alarga naturalmente nessa posição.

Expire por 6 tempos. Deixe tudo amolecer mais. Em cada expiração, deixe os joelhos caírem 1mm mais.

Fique aqui e respire. A posição faz o trabalho.

Visualize: borboleta descansando com asas abertas numa pedra quente. As asas não batem. Apenas descansam. Seus joelhos são as asas.`,
    breathe: 'Inhale to feel the stretch. Exhale to soften into it.',
    breathe_pt: 'Inspire para sentir o alongamento. Expire para amolecer nele.',
    timerCue: `Inhale.
Feel.
Exhale.
Soften.`,
    timerCue_pt: `Inspire.
Sinta.
Expire.
Amoleça.`,
    feel: 'A gentle opening across the inner thighs and perineum. The floor widening without effort.',
    feel_pt: 'Uma abertura suave nas coxas internas e períneo. O assoalho alargando sem esforço.',
    avoid: 'Do not force your knees down. Do not bear down. If hip pain, raise pillows higher.',
    avoid_pt: 'Não force os joelhos. Não faça força. Se dor no quadril, levante travesseiros mais.',
    type: 'timed',
    sets: 1,
    hold: 150,
    rest: 0,
  },

  child_pose_release: {
    id: 'child_pose_release',
    pose: 'child-pose',
    name: 'Child Pose Release',
    name_pt: 'Soltura na Posição Criança',
    sub: 'The deepest passive stretch for a tight floor.',
    sub_pt: 'O alongamento passivo mais profundo para um assoalho tenso.',
    level: 'Release',
    zone: 'Full floor 0-6cm',
    color: '#7A5A6A',
    movement: 'release',
    inst: `Kneel on a soft surface. Bring your knees wide apart. Sit back onto your heels. Stretch your arms forward on the floor.

Let your forehead rest on the floor or on a pillow. Let your belly hang between your thighs.

Inhale for 4 counts. Feel your belly expand toward the floor. Your pelvic floor lengthens between your sit bones.

Exhale for 6 counts. Let everything drop heavier. Gravity pulls your belly down and your floor opens.

Stay here for the full time. No effort. No movement. Just breathing into the stretch.

Picture it: a cat stretching after a nap. Front paws forward, hips back, belly dropped. Total surrender. Or draping a wet towel over a round surface. The towel has no shape of its own. It just falls over whatever is underneath.`,
    inst_pt: `Ajoelhe numa superfície macia. Abra os joelhos bem. Sente nos calcanhares. Estique os braços para frente no chão.

Deixe a testa descansar no chão ou num travesseiro. Deixe a barriga pendurar entre as coxas.

Inspire por 4 tempos. Sinta a barriga expandir em direção ao chão. Seu assoalho pélvico se alonga entre os ísquios.

Expire por 6 tempos. Deixe tudo cair mais pesado. A gravidade puxa a barriga para baixo e seu assoalho abre.

Fique aqui pelo tempo todo. Sem esforço. Sem movimento. Apenas respirando no alongamento.

Visualize: um gato se espreguiçando depois da soneca. Patas dianteiras para frente, quadril para trás, barriga caída. Rendição total. Ou cobrindo uma superfície arredondada com uma toalha molhada. A toalha não tem forma própria. Apenas cai.`,
    breathe: 'Inhale to lengthen. Exhale to surrender.',
    breathe_pt: 'Inspire para alongar. Expire para se render.',
    timerCue: `Inhale.
Lengthen.
Exhale.
Surrender.`,
    timerCue_pt: `Inspire.
Alongue.
Expire.
Rendição.`,
    feel: 'Deep opening across the entire pelvic floor. The belly hangs. The floor stretches.',
    feel_pt: 'Abertura profunda em todo o assoalho pélvico. A barriga pendura. O assoalho se alonga.',
    avoid: 'Do not bear down. If knees hurt, cushion between calves and thighs.',
    avoid_pt: 'Não faça força. Se joelhos doem, almofada entre panturrilhas e coxas.',
    type: 'timed',
    sets: 1,
    hold: 150,
    rest: 0,
  },

  counting_breath: {
    id: 'counting_breath',
    name: 'Counting Breath',
    name_pt: 'Respiração com Contagem',
    sub: 'Count the exhale longer. The floor follows the count.',
    sub_pt: 'Conte a expiração mais longa. O assoalho segue a contagem.',
    level: 'Release',
    zone: 'Full floor 0-3cm',
    color: '#7A5A6A',
    movement: 'release',
    inst: `Lie on your back, knees bent, feet flat. Close your eyes.

Round 1 (5 breaths): Inhale 3 counts. Exhale 5 counts. Short and calm.

Round 2 (5 breaths): Inhale 4 counts. Exhale 6 counts. A bit longer.

Round 3 (5 breaths): Inhale 4 counts. Exhale 8 counts. The longest exhale teaches your nervous system to shift into rest mode. Your pelvic floor softens more with each longer exhale.

If 8 counts is too long, stay at 6. The exhale is always longer than the inhale. That is what tells the body it is safe.

Picture it: slowly letting air out of a balloon. The longer the hiss, the flatter the balloon becomes. Your pelvic floor is the balloon. Or a train slowing into a station. Each longer exhale is a longer brake. By Round 3, the train has stopped completely.`,
    inst_pt: `Deite de costas, joelhos dobrados, pés apoiados. Feche os olhos.

Rodada 1 (5 respirações): Inspire 3 tempos. Expire 5 tempos. Curta e calma.

Rodada 2 (5 respirações): Inspire 4 tempos. Expire 6 tempos. Um pouco mais longa.

Rodada 3 (5 respirações): Inspire 4 tempos. Expire 8 tempos. A expiração mais longa ensina seu sistema nervoso a entrar em modo de descanso. Seu assoalho pélvico amolece mais a cada expiração mais longa.

Se 8 tempos for muito, fique em 6. A expiração é sempre mais longa que a inspiração. É isso que diz ao corpo que está seguro.

Visualize: soltando ar lentamente de um balão. Quanto mais longo o chiado, mais murcho fica. Seu assoalho pélvico é o balão. Ou um trem parando numa estação. Cada expiração mais longa é um freio mais longo. Na Rodada 3, o trem parou completamente.`,
    breathe: 'Round 1: in 3, out 5. Round 2: in 4, out 6. Round 3: in 4, out 8.',
    breathe_pt: 'Rodada 1: inspira 3, expira 5. Rodada 2: inspira 4, expira 6. Rodada 3: inspira 4, expira 8.',
    timerCue: `Inhale.
Count.
Exhale.
Longer.`,
    timerCue_pt: `Inspire.
Conte.
Expire.
Mais longo.`,
    feel: 'Each round gets calmer. The longer exhale shifts your whole body into rest mode.',
    feel_pt: 'Cada rodada fica mais calma. A expiração mais longa muda o corpo inteiro para modo de descanso.',
    avoid: 'Do not force longer counts. If dizzy, return to normal breathing. Do not bear down.',
    avoid_pt: 'Não force contagens mais longas. Se sentir tontura, volte à respiração normal. Não faça força.',
    type: 'hold',
    sets: 15,
    hold: 4,
    relax: 7,
    rest: 0,
  },

  hip_rock_release: {
    id: 'hip_rock_release',
    name: 'Hip Rock Release',
    name_pt: 'Balanço do Quadril',
    sub: 'Movement teaches the floor to let go.',
    sub_pt: 'Movimento ensina o assoalho a soltar.',
    level: 'Release',
    zone: 'Full floor 0-3cm',
    color: '#7A5A6A',
    movement: 'release',
    inst: `Lie on your back, knees bent, feet flat.

Slowly tilt your pelvis forward: your low back arches slightly away from the floor. Feel your pelvic floor gently stretch open.

Slowly tilt your pelvis back: your low back presses into the floor. Feel your pelvic floor gently compress.

Rock between these two positions slowly. Forward tilt opens the floor. Back tilt closes it lightly. Each rock takes about 4 seconds forward, 4 seconds back.

During the forward tilt, actively breathe into the stretch. Let the floor open.

Picture it: your pelvis is a bowl of water. Tilt forward, water tips toward your belly button. Tilt back, water tips toward your spine. Smooth, no spilling. Or a rocking chair in slow motion, the whole thing moving as one piece.`,
    inst_pt: `Deite de costas, joelhos dobrados, pés apoiados.

Lentamente incline a pelve para frente: a lombar se afasta levemente do chão. Sinta o assoalho pélvico se alongar suavemente.

Lentamente incline a pelve para trás: a lombar pressiona o chão. Sinta o assoalho pélvico comprimir levemente.

Balance entre as duas posições devagar. Inclinação frontal abre o assoalho. Inclinação posterior fecha levemente. Cada balanço leva cerca de 4 segundos para frente, 4 para trás.

Durante a inclinação frontal, respire ativamente no alongamento. Deixe o assoalho abrir.

Visualize: sua pelve é uma tigela de água. Incline para frente, água vai ao umbigo. Incline para trás, água vai à coluna. Suave, sem derramar. Ou cadeira de balanço em câmera lenta, tudo se movendo como uma peça.`,
    breathe: 'Inhale as you tilt forward (open). Exhale as you tilt back (neutral).',
    breathe_pt: 'Inspire ao inclinar para frente (abrir). Expire ao inclinar para trás (neutro).',
    timerCue: `Forward.
Open.
Back.
Neutral.`,
    timerCue_pt: `Frente.
Abra.
Trás.
Neutro.`,
    feel: 'A gentle rocking that alternates between stretching and softening. Like a wave inside your pelvis.',
    feel_pt: 'Um balanço suave que alterna entre alongar e amolecer. Como uma onda dentro da pelve.',
    avoid: 'Do not rush. Do not lift your hips off the ground. Do not bear down.',
    avoid_pt: 'Não apresse. Não levante o quadril do chão. Não faça força.',
    type: 'alt',
    sets: 19,
    hold: 4,
    relax: 4,
    rest: 0,
    altA: 'Forward',
    altA_pt: 'Frente',
    altB: 'Back',
    altB_pt: 'Trás',
  },

  jaw_floor_connection: {
    id: 'jaw_floor_connection',
    name: 'Jaw Floor Connection',
    name_pt: 'Conexão Maxilar e Assoalho',
    sub: 'Your jaw and your pelvic floor release together. Always.',
    sub_pt: 'Seu maxilar e seu assoalho pélvico soltam juntos. Sempre.',
    level: 'Release',
    zone: 'Full floor 0-3cm',
    color: '#8A6A7A',
    movement: 'release',
    inst: `Lie on your back, knees bent, feet flat. Close your eyes.

Clench your jaw tightly for 3 seconds. Notice what happens in your pelvic floor. Most women feel it tighten too. Now release your jaw completely. Let your lips part. Let your tongue rest on the floor of your mouth. Notice your pelvic floor soften.

Now breathe: inhale 4 counts with jaw soft. Feel the floor drop. Exhale 6 counts, jaw stays soft. Floor stays soft.

Every time you catch yourself clenching your jaw during the day, your pelvic floor is clenching too. Release the jaw. The floor follows.

Picture it: your jaw and pelvic floor are connected by an invisible string. When one is tight, both are tight. When one melts, both melt. Or think of two fists, one at your face and one between your legs. Open the top fist, the bottom one opens too.`,
    inst_pt: `Deite de costas, joelhos dobrados, pés apoiados. Feche os olhos.

Aperte o maxilar com força por 3 segundos. Note o que acontece no seu assoalho pélvico. A maioria das mulheres sente ele apertar também. Agora solte o maxilar completamente. Deixe os lábios se separarem. Deixe a língua descansar no fundo da boca. Note seu assoalho pélvico amolecer.

Agora respire: inspire 4 tempos com maxilar macio. Sinta o assoalho cair. Expire 6 tempos, maxilar continua macio. Assoalho continua macio.

Toda vez que se pegar apertando o maxilar durante o dia, seu assoalho pélvico está apertando também. Solte o maxilar. O assoalho segue.

Visualize: seu maxilar e assoalho pélvico estão conectados por um fio invisível. Quando um está tenso, ambos estão. Quando um derrete, ambos derretem. Ou pense em dois punhos, um no rosto e outro entre as pernas. Abra o punho de cima, o de baixo abre também.`,
    breathe: 'Inhale with jaw soft. Exhale with jaw soft. The floor follows the jaw.',
    breathe_pt: 'Inspire com maxilar macio. Expire com maxilar macio. O assoalho segue o maxilar.',
    timerCue: `Jaw soft.
Inhale.
Drop.
Exhale.`,
    timerCue_pt: `Maxilar macio.
Inspire.
Solte.
Expire.`,
    feel: 'The moment you release your jaw, your pelvic floor softens. The two are wired together.',
    feel_pt: 'No momento em que você solta a mandíbula, o assoalho pélvico também amolece. Os dois são conectados.',
    avoid: 'Do not bear down. Do not force the jaw open wide. Just let it hang slack.',
    avoid_pt: 'Não faça força. Não force o maxilar a abrir muito. Apenas deixe pendurar frouxo.',
    type: 'hold',
    sets: 12,
    hold: 4,
    relax: 6,
    rest: 0,
  },

  pelvic_floor_drop: {
    id: 'pelvic_floor_drop',
    pose: 'pf-drop',
    name: 'Pelvic Floor Drop',
    name_pt: 'Queda do Assoalho',
    sub: 'Gravity does the work. You just breathe.',
    sub_pt: 'A gravidade faz o trabalho. Você só respira.',
    level: 'Release',
    zone: 'Full floor 0-3cm',
    color: '#7A5A6A',
    movement: 'release',
    inst: `Lie on your back. Pull both knees gently toward your chest. Let them fall apart. Hold behind each knee with your hands.

Breathe in for 4 counts. Feel your pelvic floor widen between your sit bones.

Breathe out for 6 counts. Let everything drop. Nothing holds.

On each exhale, imagine the space between your sit bones getting 1mm wider. Stay in this position for the full time.

Picture it: two small islands drifting apart on a calm ocean. Each breath pushes them gently further.`,
    inst_pt: `Deite de costas. Puxe os joelhos suavemente em direção ao peito. Deixe-os cair para os lados. Segure atrás de cada joelho com as mãos.

Inspire por 4 tempos. Sinta seu assoalho pélvico alargar entre os ísquios.

Expire por 6 tempos. Deixe tudo cair. Nada segura.

Em cada expiração, imagine o espaço entre seus ísquios ficando 1mm mais largo. Fique aqui pelo tempo todo.

Visualize: duas pequenas ilhas se afastando num oceano calmo. Cada respiração as empurra suavemente.`,
    breathe: 'Inhale to widen. Exhale to drop deeper.',
    breathe_pt: 'Inspire para alargar. Expire para soltar mais fundo.',
    timerCue: `Inhale.
Widen.
Exhale.
Drop.`,
    timerCue_pt: `Inspire.
Alargue.
Expire.
Solte.`,
    feel: 'A gentle opening between the sit bones on every breath. Gravity pulling the floor downward. No effort.',
    feel_pt: 'Uma abertura suave entre os ísquios a cada respiração. Gravidade puxando o assoalho para baixo. Sem esforço.',
    avoid: 'Do not push or bear down. Do not squeeze your knees together. Do not tense your inner thighs.',
    avoid_pt: 'Não empurre nem faça força. Não aperte os joelhos juntos. Não tensione as coxas internas.',
    type: 'timed',
    sets: 1,
    hold: 150,
    rest: 0,
  },

  side_lying_release: {
    id: 'side_lying_release',
    pose: 'side-lying',
    name: 'Side Lying Release',
    name_pt: 'Soltura de Lado',
    sub: 'The gentlest position. Zero gravity load on the floor.',
    sub_pt: 'A posição mais suave. Zero carga de gravidade no assoalho.',
    level: 'Release',
    zone: 'Full floor 0-3cm',
    color: '#7A5A6A',
    movement: 'release',
    inst: `Lie on your side with a pillow between your knees. Your spine should be neutral. Place one hand on your lower belly.

Inhale for 4 counts. Feel your belly push forward against your hand. Your pelvic floor releases toward the back.

Exhale for 6 counts. Stay soft everywhere. Nothing activates.

This position removes gravity from the equation. Your floor is completely unloaded. It can release fully without fighting anything.

Picture it: a cat sleeping curled on its side. Every breath makes it softer. Every exhale melts it deeper into the cushion. Be the cat. Or snow melting on a warm windowsill, slowly and silently becoming water.`,
    inst_pt: `Deite de lado com um travesseiro entre os joelhos. Sua coluna deve estar neutra. Coloque uma mão na barriga baixa.

Inspire por 4 tempos. Sinta a barriga empurrar para frente contra sua mão. Seu assoalho pélvico solta em direção às costas.

Expire por 6 tempos. Fique macia em todo lugar. Nada ativa.

Essa posição remove a gravidade da equação. Seu assoalho está completamente descarregado. Pode soltar totalmente sem lutar contra nada.

Visualize: um gato dormindo de lado. Cada respiração o deixa mais macio. Cada expiração derrete na almofada. Seja o gato. Ou neve derretendo num parapeito quente, lenta e silenciosamente virando água.`,
    breathe: 'Inhale to expand. Exhale to stay released.',
    breathe_pt: 'Inspire para expandir. Expire para continuar solta.',
    timerCue: `Inhale.
Expand.
Exhale.
Stay soft.`,
    timerCue_pt: `Inspire.
Expanda.
Expire.
Fique macia.`,
    feel: 'Very little, by design. The point is the absence of tension.',
    feel_pt: 'Quase nada, de propósito. O ponto é a ausência de tensão.',
    avoid: 'Do not bear down. Do not try to feel anything dramatic.',
    avoid_pt: 'Não faça força. Não tente sentir nada dramático.',
    type: 'timed',
    sets: 1,
    hold: 150,
    rest: 0,
  },

  sighing_release: {
    id: 'sighing_release',
    name: 'Sighing Release',
    name_pt: 'Soltura com Suspiro',
    sub: 'Sound vibration travels down. Your floor hears it.',
    sub_pt: 'A vibração do som desce. Seu assoalho ouve.',
    level: 'Release',
    zone: 'Full floor 0-3cm',
    color: '#8A6A7A',
    movement: 'release',
    inst: `Lie on your back, knees bent, feet flat.

Inhale deeply through your nose for 4 counts.

Exhale with an audible sigh: "Ahhhhhh." Let the sound come from low in your belly, not your throat. Let it last the full 6 count exhale. Feel the vibration travel down through your torso.

As the sigh travels down, your pelvic floor releases with it. Sound and release move in the same direction: downward.

If you feel self-conscious about the sound, start with a whispered sigh.

Picture it: the sigh is warm water pouring slowly from your throat down through your belly and out through your pelvic floor, softening everything it touches. Or imagine a tuning fork placed on your chest, the vibration humming through your body, loosening each layer.`,
    inst_pt: `Deite de costas, joelhos dobrados, pés apoiados.

Inspire profundamente pelo nariz por 4 tempos.

Expire com um suspiro audível: "Ahhhhhh." Deixe o som vir do fundo da barriga, não da garganta. Deixe durar a expiração inteira de 6 tempos. Sinta a vibração viajar pelo seu torso.

Conforme o suspiro desce, seu assoalho pélvico solta com ele. Som e soltura se movem na mesma direção: para baixo.

Se sentir vergonha do som, comece com um suspiro sussurrado.

Visualize: o suspiro é água quente derramando lentamente da garganta, descendo pela barriga e saindo pelo assoalho pélvico, amolecendo tudo que toca. Ou imagine um diapasão colocado no peito, a vibração zumbindo pelo corpo, soltando cada camada.`,
    breathe: 'Inhale silently through the nose. Exhale with an audible sigh through the mouth.',
    breathe_pt: 'Inspire silenciosamente pelo nariz. Expire com um suspiro audível pela boca.',
    timerCue: `Inhale.
Sigh.
Ahhhh.
Release.`,
    timerCue_pt: `Inspire.
Suspire.
Ahhhh.
Solte.`,
    feel: 'The sigh creates a vibration that travels down. Your pelvic floor softens in response.',
    feel_pt: 'O suspiro cria uma vibração que desce. Seu assoalho pélvico amolece em resposta.',
    avoid: 'Do not force the sound. A gentle, low sigh is enough. Do not bear down while sighing.',
    avoid_pt: 'Não force o som. Um suspiro suave e baixo é suficiente. Não faça força ao suspirar.',
    type: 'hold',
    sets: 15,
    hold: 4,
    relax: 6,
    rest: 0,
  },

  towel_feedback_release: {
    id: 'towel_feedback_release',
    name: 'Towel Feedback Release',
    name_pt: 'Soltura com Feedback da Toalha',
    sub: 'The towel tells you what your floor is doing.',
    sub_pt: 'A toalha te conta o que seu assoalho está fazendo.',
    level: 'Release',
    zone: 'Full floor 0-3cm',
    color: '#8A6A7A',
    movement: 'release',
    inst: `Sit on a rolled towel placed lengthwise between your sit bones. The towel gives you physical feedback.

Inhale for 4 counts. Feel your perineum gently push against the towel as the floor drops.

Exhale for 6 counts. Stay soft. Feel the warm contact between your body and the towel.

If you notice the perineum pulling AWAY from the towel on the inhale, your floor is gripping instead of dropping. Exhale first. Then inhale again. Let it fall.

Picture it: sitting on a cloud. Each breath lets you sink 1mm deeper. The cloud holds you.`,
    inst_pt: `Sente sobre uma toalha enrolada colocada entre seus ísquios. A toalha dá feedback físico.

Inspire por 4 tempos. Sinta o períneo empurrar suavemente contra a toalha conforme o assoalho cai.

Expire por 6 tempos. Fique macia. Sinta o contato quente entre seu corpo e a toalha.

Se notar o períneo se AFASTANDO da toalha na inspiração, seu assoalho está apertando ao invés de cair. Expire primeiro. Depois inspire de novo. Deixe cair.

Visualize: sentada numa nuvem. Cada respiração te afunda 1mm mais. A nuvem te sustenta.`,
    breathe: 'Inhale to drop into the towel. Exhale to stay.',
    breathe_pt: 'Inspire para cair na toalha. Expire para ficar.',
    timerCue: `Inhale.
Drop.
Feel towel.
Exhale.`,
    timerCue_pt: `Inspire.
Solte.
Sinta toalha.
Expire.`,
    feel: 'Warmth and gentle pressure against the towel on each inhale.',
    feel_pt: 'Calor e pressão suave contra a toalha em cada inspiração.',
    avoid: 'Do not bear down onto the towel. Do not rock your pelvis.',
    avoid_pt: 'Não faça força contra a toalha. Não balance a pelve.',
    type: 'hold',
    sets: 15,
    hold: 4,
    relax: 6,
    rest: 0,
  },

  wall_supported_release: {
    id: 'wall_supported_release',
    name: 'Wall Supported Release',
    name_pt: 'Soltura Apoiada na Parede',
    sub: 'Standing release. Training the floor to let go upright.',
    sub_pt: 'Soltura em pé. Treinando o assoalho a soltar de pé.',
    level: 'Release',
    zone: 'Full floor 0-3cm',
    color: '#8A6A7A',
    movement: 'release',
    inst: `Stand with your back against a wall. Feet hip-width apart, about 30cm from the wall. Knees slightly bent.

Let the wall hold your weight. Your body should feel supported, not working.

Inhale for 4 counts. Feel your belly expand forward. Let your pelvic floor drop, even though you are standing.

Exhale for 6 counts. Stay soft. Do not tighten.

This is harder than lying down because gravity pulls on the organs. If you cannot feel the drop while standing, that is normal. The awareness develops with repetition.

Picture it: leaning against a warm tree trunk in a forest. Your back rests on the tree. Your body melts into it. Or a backpack hanging on a hook. The wall is the hook. You are the backpack. Everything hangs. Nothing works.`,
    inst_pt: `Fique de costas para a parede. Pés na largura do quadril, cerca de 30cm da parede. Joelhos levemente dobrados.

Deixe a parede segurar seu peso. Seu corpo deve se sentir apoiado, não trabalhando.

Inspire por 4 tempos. Sinta a barriga expandir para frente. Deixe o assoalho pélvico cair, mesmo de pé.

Expire por 6 tempos. Fique macia. Não contraia.

Isso é mais difícil que deitada porque a gravidade puxa os órgãos. Se não conseguir sentir a queda de pé, é normal. A consciência se desenvolve com repetição.

Visualize: encostada num tronco de árvore quente numa floresta. Suas costas descansam na árvore. Seu corpo derrete nela. Ou uma mochila pendurada num gancho. A parede é o gancho. Você é a mochila. Tudo pendura. Nada trabalha.`,
    breathe: 'Inhale to expand. Exhale to stay expanded.',
    breathe_pt: 'Inspire para expandir. Expire para continuar expandida.',
    timerCue: `Inhale.
Expand.
Exhale.
Stay open.`,
    timerCue_pt: `Inspire.
Expanda.
Expire.
Fique aberta.`,
    feel: 'The same drop you feel lying down, but lighter and subtler. The wall holds you.',
    feel_pt: 'A mesma queda que sente deitada, mas mais leve e sutil. A parede te segura.',
    avoid: 'Do not push away from the wall. Do not bear down. Do not lock your knees.',
    avoid_pt: 'Não empurre para longe da parede. Não faça força. Não trave os joelhos.',
    type: 'hold',
    sets: 15,
    hold: 4,
    relax: 6,
    rest: 0,
  },

  warm_hands_release: {
    id: 'warm_hands_release',
    name: 'Warm Hands Release',
    name_pt: 'Soltura com Mãos Quentes',
    sub: 'Warmth tells your body it is safe to soften.',
    sub_pt: 'Calor diz ao corpo que é seguro amolecer.',
    level: 'Release',
    zone: 'Full floor 0-3cm',
    color: '#8A6A7A',
    movement: 'release',
    inst: `Rub your palms together vigorously for 10 seconds until they feel warm.

Lie on your back, knees bent. Place both warm hands on your lower belly, below your belly button. Let the warmth sink in.

Inhale for 4 counts. Feel the warmth spread deeper as your belly rises. Your pelvic floor responds to warmth by softening.

Exhale for 6 counts. Imagine the warmth melting down from your hands, through your belly, to your pelvic floor.

When your hands cool, rub them together again and resume.

Picture it: your hands are two warm stones placed on your belly. The heat radiates downward through layers of muscle.`,
    inst_pt: `Esfregue as palmas das mãos vigorosamente por 10 segundos até ficarem quentes.

Deite de costas, joelhos dobrados. Coloque ambas as mãos quentes na barriga baixa, abaixo do umbigo. Deixe o calor penetrar.

Inspire por 4 tempos. Sinta o calor se espalhar mais fundo conforme a barriga sobe.

Expire por 6 tempos. Imagine o calor derretendo das suas mãos, através da barriga, até o assoalho pélvico.

Quando as mãos esfriarem, esfregue de novo e continue.

Visualize: suas mãos são duas pedras quentes colocadas na barriga. O calor irradia para baixo.`,
    breathe: 'Inhale to receive the warmth. Exhale to send it deeper.',
    breathe_pt: 'Inspire para receber o calor. Expire para enviar mais fundo.',
    timerCue: `Warmth.
Inhale.
Deeper.
Exhale.`,
    timerCue_pt: `Calor.
Inspire.
Mais fundo.
Expire.`,
    feel: 'Spreading warmth from hands through belly to pelvic floor.',
    feel_pt: 'Calor se espalhando das mãos pela barriga ao assoalho pélvico.',
    avoid: 'Do not press your hands into your belly. Do not bear down.',
    avoid_pt: 'Não pressione as mãos na barriga. Não faça força.',
    type: 'hold',
    sets: 12,
    hold: 4,
    relax: 6,
    rest: 0,
  },
};

export const days = [
  {
    day: 1, week: 1,
    title: 'Day 1', title_pt: 'Dia 1',
    exercises: [
      { ref: 'pelvic_floor_drop', overrides: {} }, // 150s
      { ref: 'hip_rock_release', overrides: {} }, // 152s
    ], // Total: 302s = 5.0 min
  },
  {
    day: 2, week: 1,
    title: 'Day 2', title_pt: 'Dia 2',
    exercises: [
      { ref: 'counting_breath', overrides: {"sets": 14} }, // 154s
      { ref: 'warm_hands_release', overrides: {"sets": 15} }, // 150s
    ], // Total: 304s = 5.1 min
  },
  {
    day: 3, week: 1,
    title: 'Day 3', title_pt: 'Dia 3',
    exercises: [
      { ref: 'warm_hands_release', overrides: {"sets": 15} }, // 150s
      { ref: 'body_scan_release', overrides: {} }, // 150s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 4, week: 1,
    title: 'Day 4', title_pt: 'Dia 4',
    exercises: [
      { ref: 'side_lying_release', overrides: {"hold": 100.0} }, // 100.0s
      { ref: 'counting_breath', overrides: {"sets": 9} }, // 99s
      { ref: 'child_pose_release', overrides: {"hold": 101.0} }, // 101.0s
    ], // Total: 300.0s = 5.0 min
  },
  {
    day: 5, week: 1,
    title: 'Day 5', title_pt: 'Dia 5',
    exercises: [
      { ref: 'jaw_floor_connection', overrides: {"sets": 10} }, // 100s
      { ref: 'wall_supported_release', overrides: {"sets": 10} }, // 100s
      { ref: 'warm_hands_release', overrides: {"sets": 10} }, // 100s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 6, week: 1,
    title: 'Day 6', title_pt: 'Dia 6',
    exercises: [
      { ref: 'towel_feedback_release', overrides: {} }, // 150s
      { ref: 'child_pose_release', overrides: {} }, // 150s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 7, week: 1,
    title: 'Day 7', title_pt: 'Dia 7',
    exercises: [
      { ref: 'counting_breath', overrides: {"sets": 9} }, // 99s
      { ref: 'hip_rock_release', overrides: {"sets": 12} }, // 96s
      { ref: 'butterfly_breath', overrides: {"hold": 105} }, // 105s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 8, week: 2,
    title: 'Day 8', title_pt: 'Dia 8',
    exercises: [
      { ref: 'jaw_floor_connection', overrides: {"sets": 15} }, // 150s
      { ref: 'body_scan_release', overrides: {} }, // 150s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 9, week: 2,
    title: 'Day 9', title_pt: 'Dia 9',
    exercises: [
      { ref: 'towel_feedback_release', overrides: {"sets": 10} }, // 100s
      { ref: 'body_scan_release', overrides: {"hold": 100.0} }, // 100.0s
      { ref: 'warm_hands_release', overrides: {"sets": 10} }, // 100s
    ], // Total: 300.0s = 5.0 min
  },
  {
    day: 10, week: 2,
    title: 'Day 10', title_pt: 'Dia 10',
    exercises: [
      { ref: 'wall_supported_release', overrides: {"sets": 10} }, // 100s
      { ref: 'butterfly_breath', overrides: {"hold": 100.0} }, // 100.0s
      { ref: 'warm_hands_release', overrides: {"sets": 10} }, // 100s
    ], // Total: 300.0s = 5.0 min
  },
  {
    day: 11, week: 2,
    title: 'Day 11', title_pt: 'Dia 11',
    exercises: [
      { ref: 'body_scan_release', overrides: {} }, // 150s
      { ref: 'sighing_release', overrides: {} }, // 150s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 12, week: 2,
    title: 'Day 12', title_pt: 'Dia 12',
    exercises: [
      { ref: 'belly_breath_drop', overrides: {} }, // 150s
      { ref: 'butterfly_breath', overrides: {} }, // 150s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 13, week: 2,
    title: 'Day 13', title_pt: 'Dia 13',
    exercises: [
      { ref: 'sighing_release', overrides: {} }, // 150s
      { ref: 'warm_hands_release', overrides: {"sets": 15} }, // 150s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 14, week: 2,
    title: 'Day 14', title_pt: 'Dia 14',
    exercises: [
      { ref: 'jaw_floor_connection', overrides: {"sets": 15} }, // 150s
      { ref: 'towel_feedback_release', overrides: {} }, // 150s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 15, week: 3,
    title: 'Day 15', title_pt: 'Dia 15',
    exercises: [
      { ref: 'hip_rock_release', overrides: {} }, // 152s
      { ref: 'child_pose_release', overrides: {"hold": 148} }, // 148s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 16, week: 3,
    title: 'Day 16', title_pt: 'Dia 16',
    exercises: [
      { ref: 'sighing_release', overrides: {} }, // 150s
      { ref: 'belly_breath_drop', overrides: {} }, // 150s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 17, week: 3,
    title: 'Day 17', title_pt: 'Dia 17',
    exercises: [
      { ref: 'jaw_floor_connection', overrides: {"sets": 10} }, // 100s
      { ref: 'child_pose_release', overrides: {"hold": 100.0} }, // 100.0s
      { ref: 'belly_breath_drop', overrides: {"sets": 10} }, // 100s
    ], // Total: 300.0s = 5.0 min
  },
  {
    day: 18, week: 3,
    title: 'Day 18', title_pt: 'Dia 18',
    exercises: [
      { ref: 'side_lying_release', overrides: {} }, // 150s
      { ref: 'butterfly_breath', overrides: {} }, // 150s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 19, week: 3,
    title: 'Day 19', title_pt: 'Dia 19',
    exercises: [
      { ref: 'warm_hands_release', overrides: {"sets": 15} }, // 150s
      { ref: 'pelvic_floor_drop', overrides: {} }, // 150s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 20, week: 3,
    title: 'Day 20', title_pt: 'Dia 20',
    exercises: [
      { ref: 'sighing_release', overrides: {} }, // 150s
      { ref: 'belly_breath_drop', overrides: {} }, // 150s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 21, week: 3,
    title: 'Day 21', title_pt: 'Dia 21',
    exercises: [
      { ref: 'wall_supported_release', overrides: {} }, // 150s
      { ref: 'sighing_release', overrides: {} }, // 150s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 22, week: 4,
    title: 'Day 22', title_pt: 'Dia 22',
    exercises: [
      { ref: 'wall_supported_release', overrides: {} }, // 150s
      { ref: 'child_pose_release', overrides: {} }, // 150s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 23, week: 4,
    title: 'Day 23', title_pt: 'Dia 23',
    exercises: [
      { ref: 'warm_hands_release', overrides: {"sets": 15} }, // 150s
      { ref: 'jaw_floor_connection', overrides: {"sets": 15} }, // 150s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 24, week: 4,
    title: 'Day 24', title_pt: 'Dia 24',
    exercises: [
      { ref: 'body_scan_release', overrides: {} }, // 150s
      { ref: 'wall_supported_release', overrides: {} }, // 150s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 25, week: 4,
    title: 'Day 25', title_pt: 'Dia 25',
    exercises: [
      { ref: 'body_scan_release', overrides: {} }, // 150s
      { ref: 'sighing_release', overrides: {} }, // 150s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 26, week: 4,
    title: 'Day 26', title_pt: 'Dia 26',
    exercises: [
      { ref: 'child_pose_release', overrides: {} }, // 150s
      { ref: 'sighing_release', overrides: {} }, // 150s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 27, week: 4,
    title: 'Day 27', title_pt: 'Dia 27',
    exercises: [
      { ref: 'counting_breath', overrides: {"sets": 9} }, // 99s
      { ref: 'warm_hands_release', overrides: {"sets": 10} }, // 100s
      { ref: 'hip_rock_release', overrides: {"sets": 13} }, // 104s
    ], // Total: 303s = 5.0 min
  },
  {
    day: 28, week: 4,
    title: 'Day 28', title_pt: 'Dia 28',
    exercises: [
      { ref: 'pelvic_floor_drop', overrides: {"hold": 100.0} }, // 100.0s
      { ref: 'towel_feedback_release', overrides: {"sets": 10} }, // 100s
      { ref: 'wall_supported_release', overrides: {"sets": 10} }, // 100s
    ], // Total: 300.0s = 5.0 min
  },
  {
    day: 29, week: 5,
    title: 'Day 29', title_pt: 'Dia 29',
    exercises: [
      { ref: 'warm_hands_release', overrides: {"sets": 10} }, // 100s
      { ref: 'counting_breath', overrides: {"sets": 9} }, // 99s
      { ref: 'body_scan_release', overrides: {"hold": 101} }, // 101s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 30, week: 5,
    title: 'Day 30', title_pt: 'Dia 30',
    exercises: [
      { ref: 'body_scan_release', overrides: {} }, // 150s
      { ref: 'warm_hands_release', overrides: {"sets": 15} }, // 150s
    ], // Total: 300s = 5.0 min
  },
];


export const monthMeta = {
  month: 1,
  program: 'release',
  phase: 'Pure Release',
  phase_pt: 'Soltura Pura',
  days_range: [1, 30],
  session_target_seconds: 300,
};

export function resolveDay(dayNumber) {
  const dayData = days.find(d => d.day === dayNumber);
  if (!dayData) return null;
  return { ...dayData, exercises: dayData.exercises.map(ex => ({ ...exercises[ex.ref], ...ex.overrides })) };
}